module.exports = __webpack_public_path__ + "media/customizations/woodcreek/back-84a6bb90faf2ea54e0c3da161951665f.jpg";